import responseParsers from './responseParsers';
var EventSinkhole = {
    on: function (eventName, ctx) { },
};
export var defaultFetchOptions = {
    method: 'get',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    queryParams: {},
    parseResponse: responseParsers.json,
    tries: 1,
    retryTimeout: 500,
    eventCapture: EventSinkhole,
};
//# sourceMappingURL=types.js.map